import React, { ReactNode, useEffect } from 'react'
import Typography from '../components/typography'
import Card from '../components/card'
import PageLayout from './page_layout'
import AuthBackground from '../assets/images/auth_page_background.jpg'
import { trackUserIdentify } from '../utils/analytics'
import userCurrentUserId from '../hooks/useCurrentUserId';

interface AuthPageLayoutProps {
  children: ReactNode
  title: string
  onFormSubmit?: () => Promise<void>
}

const AuthPageLayout: React.FC<AuthPageLayoutProps> = (props) => {
  const { children, title } = props
  const userId = userCurrentUserId();

  useEffect(() => {
    async function trackAuthIdentity (): Promise<void> {
      await trackUserIdentify(userId);
    }
    void trackAuthIdentity()
  }, [userId]);

  return (
    <PageLayout childrenBackground={`url(${AuthBackground}) no-repeat center center fixed`}>
      <Card color='primary' sx={{
        border: '1px solid #ffffff',
        borderRadius: '8px',
        marginTop: '20%',
        padding: '24px 36px 36px 36px',
        maxWidth: '400px',
        marginLeft: 'auto',
        marginRight: 'auto'
      }} raised>
        <Typography textAlign={'left'} mb={'12px'} variant={'h4'}>{title}</Typography>
        {children}
      </Card>
    </PageLayout>
  )
}

export default AuthPageLayout
